export function customGaEvent(payload: Record<string, unknown>): void {
	const dataLayer = ((window as any).dataLayer =
		(window as any).dataLayer ?? []);
	dataLayer.push(payload);
}